import styled from "styled-components";
import { device } from "./Devices";

export default styled.form`
  border-radius: 8px;
  ${(props) =>
    props.internal
      ? `background-color: #fff; margin: 0px 0px;padding: 0px 0px;`
      : `background-color: #fff;border: 1px solid var(--app-border);padding: 0px 0px;box-shadow: var(--app-shadow-soft);`}

  flex-basis: 100%;
  @media ${device.laptop} {
    flex: 1.5;
    ${(props) =>
      props.internal
        ? `background-color: #fff; margin: 0px 20px;padding: 24px;`
        : `background-color: #fff;border: 1px solid var(--app-border);padding: 32px;box-shadow: var(--app-shadow-soft);`}
  }

  ${(props) =>
    props.noPad ? `margin: 0px 0px!important;padding: 0px 0px!important;` : ``}

  h2 {
    color: var(--app-ink);
    font-weight: 700;
  }
`;
